/**
 * 前台评估记录页面
 * 不论是否登录都显示产品介绍页
 */

import AssessmentsLanding from "@/pages/AssessmentsLanding";

export default function Assessments() {
  return <AssessmentsLanding />;
}
